import React from 'react'
import { useTranslation } from '@/localization/useTranslation'
import { AuthErrorType, AuthOptionType } from '@/actors/AuthActor/types'
import { TextInput } from '@/components/Inputs'
import { useForm } from 'react-hook-form'
import { Button } from '@/components/Buttons/Button'
import { useAuth } from '@/hooks/auth/useAuth'
import { EMAIL_REGEX } from '@/constants/auth'
import { LoadingOverlay } from '@/components/Loading/Overlay'
import { AuthErrorModal } from '@/actors/AuthActor/components/AuthErrorModal'
import { FormHeader } from '@/actors/AuthActor/components/FormHeader'
import classes from './style.module.scss'

interface JoinnusProps {
  handleNavigateToForm: (mode: string) => void
  form?: AuthOptionType['options']['login']
}

export const JoinnusAuth: React.FC<JoinnusProps> = (props) => {
  const { handleNavigateToForm, form } = props
  const { t } = useTranslation()
  const { register, handleSubmit, formState: { errors, isDirty } } = useForm({
    defaultValues: {
      username: '',
      password: ''
    }
  })
  const { ssoMutation } = useAuth()
  const { reset, isPending, error } = ssoMutation

  const handleError = () => {
    reset()
  }

  const handleRedirect = (path: string) => {
    reset()
    handleNavigateToForm(path)
  }

  const handleBack = () => {
    handleNavigateToForm('main')
  }

  const onSubmit = async (data: any) => {
    try {
      await ssoMutation.mutateAsync({ ...data, provider: 'joinnus' })
    } catch (err) {
      console.error('Error during SSO authentication:', err)
    }
  }

  return (
    <>
      <LoadingOverlay isLoading={isPending} />
      <AuthErrorModal
        error={error as unknown as AuthErrorType}
        handleError={handleError}
        handleRedirect={handleRedirect}
      />
      <FormHeader title={form?.title} subtitle={form?.subtitle} />
      <form action="#" onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.fields}>
          <TextInput
            errors={errors}
            type="email"
            label={t('Email')}
            required
            {...register('username', {
              required: {
                value: true,
                message: t('Email is required')
              },
              pattern: {
                value: EMAIL_REGEX,
                message: t('Invalid email')
              },
            })}
          />
          <TextInput
            errors={errors}
            type="password"
            label={t('Password')}
            required
            {...register('password', {
              required: {
                value: true,
                message: t('Password is required')
              }
            })}
          />
        </div>
        <Button
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={!isDirty}
          fullWidth
        >
          {t('Log in')}
        </Button>
        <Button
          variant="secondary"
          onClick={handleBack}
          fullWidth
        >
          {t('Back')}
        </Button>
      </form>
    </>
  )
}
